import React from 'react';
import { TokenAuthResponsePayload } from '@quality24/feedback-typings';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface SignInOptions<T = Record<string, any>> {
  onCompleted?: (session: T) => void;
  onError?: (err: Error) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface AuthContext<T = Record<string, any>> {
  isAuthenticated: boolean;
  loading: boolean;
  userData: T;

  signIn: (
    token: string,
    options?: SignInOptions<T>,
  ) => Promise<TokenAuthResponsePayload>;
  signOut: () => Promise<void>;
  addData: (d: Partial<T>) => void;
  removeData: (k: string) => void;
  updateData: (k: string, newValue: unknown) => void;
}

// The initial authorization context
const context = React.createContext<AuthContext>({
  isAuthenticated: false,
  loading: false,
  userData: {},

  signIn: async () => ({} as TokenAuthResponsePayload),
  signOut: async () => {},
  addData: () => {},
  removeData: () => {},
  updateData: () => {},
});

export default context;
